class Carousel {
  constructor(id, config) {
    this.el = document.getElementById(id);
    this.config = config;
    this.carousel = null;
    this.Init();
  }

  Init() {
    if (this.el) {
      this.carousel = new Splide(this.el, this.config);
      this.carousel.mount();
    }
  }
}

window.addEventListener("load", () => {
  let carouselAlbum = new Carousel("jsCarouselAlbum", {
    autoWidth: false,
    perMove: 1,
    perPage: 1,
    autoplay: false,
    gap: "30px",
    speed: 1000,
    arrows: false,
    pagination: true,
  });

  let carouselFeedback = new Carousel("jsCarouselFeedback", {
    autoWidth: false,
    perMove: 1,
    perPage: 3,
    autoplay: false,
    gap: "60px",
    speed: 1000,
    arrows: false,
    pagination: true,
    breakpoints: {
      1199: {
        perPage: 2,
        gap: "30px",
      },
      767: {
        autoWidth: true,
        gap: "15px",
      },
    },
  });

  let carouselMember = new Carousel("jsCarouselMember", {
    autoWidth: false,
    perMove: 1,
    perPage: 3,
    autoplay: false,
    gap: "60px",
    speed: 1000,
    arrows: false,
    pagination: true,
    breakpoints: {
      1199: {
        perPage: 2,
        gap: "30px",
      },
      767: {
        autoWidth: true,
        gap: "15px",
      },
    },
  });

  let carouselTraining = new Carousel("jsCarouselTraining", {
    autoWidth: false,
    perMove: 1,
    perPage: 1,
    autoplay: false,
    gap: "30px",
    speed: 1000,
    arrows: false,
    pagination: true,
    breakpoints: {
      767: {
        gap: "15px",
      },
    },
  });
});
